import { Skeleton } from "@mui/material";
import React from "react";

const SkeletonProposalDetail = () => {
  return (
    <>
      <Skeleton
        height={400}
        sx={{ marginBottom: "-140px", marginTop: "-60px" }}
      />
      <Skeleton height={400} sx={{ marginBottom: "-150px" }} />
      <Skeleton height={500} />
    </>
  );
};

export default SkeletonProposalDetail;
